<template>
    <el-dialog :title="dialogName" :visible.sync="dialogVisible" width="600px" :close-on-click-modal="false" :modal-append-to-body="true">
      <div class="main-box">
        <el-form ref="dataForm" id="dataForm" :model="temp" :rules="rules" label-width="160px" label-suffix="：">
          <el-card class="box-card form-card" style="margin-top: 10px;">
            <el-row :gutter="15">
              <el-col :span="24">
                <el-form-item label="公司名称">天津桐昊卓创科技有限公司</el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="统一社会信用代码">91120116MA06QF46XD</el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="开户银行">中国建设银行股份有限公司天津河北支行</el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="账户号码">12050166080000003462</el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="账户名称">天津桐昊卓创科技有限公司</el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="银行地址">天津市河北区平安街68号</el-form-item>
              </el-col>
            </el-row>
          </el-card>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <xr-button type="default" @click.native="dialogVisible = false">关闭</xr-button>
      </div>
    </el-dialog>

</template>

<script>
    export default {
        name: "CompanyInfo",
        data() {
          return {
            dialogName: '充值信息',
            dialogVisible: false,                                        //弹框
            temp: {
              themeType :'',
            },
            rules: []
          }
        },
        components: {

        },
        methods: {
          init(){
            this.dialogVisible = true;
          }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/header/CompanyInfo.vue